<div [formGroup]="searchForm" novalidate class="search-box">

    <vedrax-control *ngFor="let filter of filters" [control]="getControl(filter)" [descriptor]="filter">
    </vedrax-control>

</div>
